export const head_table = [
	{ name: "Nombre comercial", size: 40, order: "tradename" },
	{
		name: "Contenido",
		size: 20,
		order: "container_content",
	},
	{
		name: "U.M.",
		size: 10,
		order: "unit_measurement",
	},
	{
		name: "Cantidad de envases",
		size: 20,
		order: "container_quantity",
	},
	{ name: "", size: 8, order: "" },
];

export const base_filters = {
	unit_measurement: 1000,
	date: "",
	dateTo: "",
	show_all: 0,
};
